
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
// import { init, ECharts, EChartsOption } from "echarts";
import * as echarts from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
const normalDataJR = [
  {
    title: '每股指标',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '基本每股收益',
    unit: '元',
    dataIndex: 'BasicEPS',
    key: 'BasicEPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '扣非每股收益',
    unit: '元',
    dataIndex: 'DNEPS',
    key: 'DNEPS',
    slots: { customRender: 'decimal4' }
  },
  {
    title: '稀释每股收益',
    unit: '元',
    dataIndex: 'DilutedEPS',
    key: 'DilutedEPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '每股净资产',
    unit: '元',
    dataIndex: 'NetAssetPS',
    key: 'NetAssetPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '每股资本公积金',
    unit: '元',
    dataIndex: 'AccumulationFundPS',
    key: 'AccumulationFundPS',
    // width: "100px",
    slots: { customRender: 'decimal4' }
  },
  {
    title: '每股未分配利润',
    unit: '元',
    dataIndex: 'UndividedProfit',
    key: 'UndividedProfit',
    // width: "100px",
    slots: { customRender: 'decimal4' }
  },
  {
    title: '每股经营现金流',
    unit: '元',
    dataIndex: 'OperCashFlowPS',
    key: 'OperCashFlowPS',
    // width: "100px",
    slots: { customRender: 'decimal4' },
    ellipsis: true
  },
  {
    title: '成长能力',
    dataIndex: 'time',
    key: 'time',
    bold: true
  },
  {
    title: '营业收入',
    unit: '元',
    dataIndex: 'OperatingRevenue',
    key: 'OperatingRevenue',
    slots: { customRender: 'peopleCount' }
    // width: "100px"
  },
  {
    title: '归属净利润',
    unit: '元',
    dataIndex: 'NPParentCompany',
    key: 'NPParentCompany',
    slots: { customRender: 'peopleCount' }
    // width: "100px"
  },
  {
    title: '扣非净利润',
    unit: '元',
    dataIndex: 'NetProfitCut',
    key: 'NetProfitCut',
    // ellipsis: true,
    slots: { customRender: 'peopleCount' }
  },
  {
    title: '营业总收入同比增长',
    dataIndex: 'OperatingRevenueYOY',
    key: 'OperatingRevenueYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '归属净利润同比增长',
    dataIndex: 'NPParentCompanyYOY',
    key: 'NPParentCompanyYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '扣非净利润同比增长',
    dataIndex: 'NPParentCompanyCutYOY',
    key: 'NPParentCompanyCutYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '营业收入滚动环比增长',
    dataIndex: 'OperatingRevenueMOM',
    key: 'OperatingRevenueMOM',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '归属净利润滚动环比增长',
    dataIndex: 'NPParentCompanyMOM',
    key: 'NPParentCompanyMOM',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '盈利能力',
    dataIndex: 'time',
    key: 'time',
    bold: true
  },
  {
    title: '净资产收益率(加权)',
    dataIndex: 'ROEWeighted',
    key: 'ROEWeighted',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '净资产收益率(扣非/加权)',
    dataIndex: 'ROECutWeighted',
    key: 'ROECutWeighted',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '总资产收益率(加权)',
    dataIndex: 'ROA',
    key: 'ROA',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '财务风险',
    dataIndex: 'time',
    key: 'time',
    bold: true
  },
  {
    title: '资产负债率',
    dataIndex: 'DebtAssetsRatio',
    key: 'DebtAssetsRatio',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '权益乘数',
    dataIndex: 'EquityMultipler',
    key: 'EquityMultipler',
    slots: { customRender: 'decimal' }
  },
  {
    title: '产权比率',
    dataIndex: 'PropertyRatio',
    key: 'PropertyRatio',
    slots: { customRender: 'decimal' }
  }
]
const normalData = [
  {
    title: '每股收益',
    dataIndex: 'time',
    key: 'time',
    bold: true
  },
  {
    title: '基本每股收益',
    unit: '元',
    dataIndex: 'BasicEPS',
    key: 'BasicEPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '扣非每股收益',
    unit: '元',
    dataIndex: 'DNEPS',
    key: 'DNEPS',
    slots: { customRender: 'decimal4' }
  },
  {
    title: '稀释每股收益',
    unit: '元',
    dataIndex: 'DilutedEPS',
    key: 'DilutedEPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '每股净资产',
    unit: '元',
    dataIndex: 'NetAssetPS',
    key: 'NetAssetPS',
    slots: { customRender: 'decimal4' }
    // width: "100px"
  },
  {
    title: '每股资本公积金',
    unit: '元',
    dataIndex: 'AccumulationFundPS',
    key: 'AccumulationFundPS',
    // width: "100px",
    slots: { customRender: 'decimal4' }
  },
  {
    title: '每股未分配利润',
    unit: '元',
    dataIndex: 'UndividedProfit',
    key: 'UndividedProfit',
    // width: "100px",
    slots: { customRender: 'decimal4' }
  },
  {
    title: '每股经营现金流',
    unit: '元',
    dataIndex: 'OperCashFlowPS',
    key: 'OperCashFlowPS',
    // width: "100px",
    slots: { customRender: 'decimal4' },
    ellipsis: true
  },
  {
    title: '成长能力',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '营业收入',
    unit: '元',
    dataIndex: 'OperatingRevenue',
    key: 'OperatingRevenue',
    slots: { customRender: 'peopleCount' }
    // width: "100px"
  },
  {
    title: '归属净利润',
    unit: '元',
    dataIndex: 'NPParentCompany',
    key: 'NPParentCompany',
    slots: { customRender: 'peopleCount' }
    // width: "100px"
  },
  {
    title: '扣非净利润',
    unit: '元',
    dataIndex: 'NetProfitCut',
    key: 'NetProfitCut',
    // ellipsis: true,
    slots: { customRender: 'peopleCount' }
  },
  {
    title: '营业总收入同比增长',
    dataIndex: 'OperatingRevenueYOY',
    key: 'OperatingRevenueYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '归属净利润同比增长',
    dataIndex: 'NPParentCompanyYOY',
    key: 'NPParentCompanyYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '扣非净利润同比增长',
    dataIndex: 'NPParentCompanyCutYOY',
    key: 'NPParentCompanyCutYOY',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '营业收入滚动环比增长',
    dataIndex: 'OperatingRevenueMOM',
    key: 'OperatingRevenueMOM',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '归属净利润滚动环比增长',
    dataIndex: 'NPParentCompanyMOM',
    key: 'NPParentCompanyMOM',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '扣非净利润滚动环比增长',
    dataIndex: 'NPParentCompanyCutMOM',
    key: 'NPParentCompanyCutMOM',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '盈利能力',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '净资产收益率(加权)',
    dataIndex: 'ROEWeighted',
    key: 'ROEWeighted',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '净资产收益率(扣非/加权)',
    dataIndex: 'ROECutWeighted',
    key: 'ROECutWeighted',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '总资产收益率(加权)',
    dataIndex: 'ROA',
    key: 'ROA',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '销售毛利率',
    dataIndex: 'GrossIncomeRatio',
    key: 'GrossIncomeRatio',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '销售净利率',
    dataIndex: 'SellNetProfitRatio',
    key: 'SellNetProfitRatio',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '财务风险',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '流动比率',
    dataIndex: 'CurrentRatio',
    key: 'CurrentRatio',
    slots: { customRender: 'decimal' }
  },
  {
    title: '速动比率',
    dataIndex: 'QuickRatio',
    key: 'QuickRatio',
    slots: { customRender: 'decimal' }
  },
  {
    title: '现金流量比率',
    dataIndex: 'NOCFToCurrentLiability',
    key: 'NOCFToCurrentLiability',
    slots: { customRender: 'decimal' }
  },
  {
    title: '资产负债率',
    dataIndex: 'DebtAssetsRatio',
    key: 'DebtAssetsRatio',
    unit: '%',
    slots: { customRender: 'nocolorincrease' }
  },
  {
    title: '权益乘数',
    dataIndex: 'EquityMultipler',
    key: 'EquityMultipler',
    slots: { customRender: 'decimal' }
  },
  {
    title: '产权比率',
    dataIndex: 'PropertyRatio',
    key: 'PropertyRatio',
    slots: { customRender: 'decimal' }
  },
  {
    title: '营运能力',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '总资产周转天数',
    unit: '天',
    dataIndex: 'TotalAssetsTDays',
    key: 'TotalAssetsTDays',
    slots: { customRender: 'decimal' }
  },
  {
    title: '存货周转天数',
    unit: '天',
    dataIndex: 'InventoryTDays',
    key: 'InventoryTDays',
    slots: { customRender: 'decimal' }
  },
  {
    title: '应收账款周转天数',
    unit: '天',
    dataIndex: 'ARTDays',
    key: 'ARTDays',
    slots: { customRender: 'decimal' }
  },
  {
    title: '总资产周转率',
    unit: '次',
    dataIndex: 'TotalAssetTRate',
    key: 'TotalAssetTRate',
    slots: { customRender: 'decimal4' }
  },
  {
    title: '存货周转率',
    unit: '次',
    dataIndex: 'InventoryTRate',
    key: 'InventoryTRate',
    slots: { customRender: 'decimal4' }
  },
  {
    title: '应收账款周转率',
    unit: '次',
    dataIndex: 'ARTRate',
    key: 'ARTRate',
    slots: { customRender: 'decimal4' }
  }
]

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Charts, InfoCircleOutlined, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      chartTit: '基本每股收益', // 柱状图的tit
      chartKey: 'BasicEPS', // 对象的key
      unit: '元',
      idx: 0, // 第几个对象
      data: [],
      columns: [],
      dataInfo: [], // 表格数据
      tags: [],
      activeTagVal: 1,
      option: {},
      spinning: true
    })
    pageData.columns = computed(() => {
      const colm = (props.pageSourceData || {}).EnterpriseType === 99 ? normalData : normalDataJR
      if (pageData.activeTagVal === 3) {
        const idx = (colm || []).findIndex((item: any) => item.title === '财务风险')
        return colm.slice(0, idx)
      } else {
        return colm
      }
    })

    pageData.tags = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      },
      {
        label: '按单季度',
        value: 3
      }
    ]
    function checkTag(tag: any) {
      pageData.activeTagVal = tag.value
      // getDetail(pageData.current, pageData.size, tag.value);
      getDetail(pageData.activeTagVal)
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 1
      }
      data.headers = {
        token: props.token
      }
      f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).Quota))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Quota' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        } else {
          pageData.data = []
        }
        // nextTick(() => {
        //   pageData.spinning = false
        //   // setoption()
        // })
      })
    }
    function checkCurrent(item: any, idx: number) {
      if (item.key === 'time') return
      pageData.chartTit = item.title
      pageData.chartKey = item.key
      pageData.unit = item.unit
      pageData.idx = idx
      const dom: any = document.querySelectorAll('.ant-anchor-link-title')
      dom[0].click()
    }
    const color = globalsets.getColor()
    // onMounted(() => {
    function setOptions() {
      const data = [...pageData.data]
      data.reverse()
      const xAxisData: any = []
      data.forEach((element: any) => {
        xAxisData.push(element.time)
      })
      const yAxisData: any = []
      data.forEach((element: any) => {
        yAxisData.push(element[pageData.chartKey])
      })
      let legentcolor = '#0060FF'
      if (props.theme === 'dark') {
        legentcolor = '#0060FF'
      }
      return {
        color: color,
        legend: {
          show: false
        },
        tooltip: {
          borderWidth: 0,
          trigger: 'axis',
          formatter: (params: any) => {
            params = params[0]
            const nameArr = [
              '基本每股收益',
              '扣非每股收益',
              '稀释每股收益',
              '每股净资产',
              '每股资本公积金',
              '每股未分配利润',
              '每股经营现金流',
              '总资产周转率',
              '存货周转率',
              '应收账款周转率'
            ]
            let res = ''
            if (nameArr.indexOf(params.seriesName) > -1) {
              res = parseFloat(params.value).toString() !== 'NaN' ? (params.value || 0).toFixed(4) : '—'
            } else {
              res = String(globalsets.getNumber2(params.value))
            }
            return `<div class="tool-tip" ><p>${params.name}</p><div style='color: #000000;'><i style="background-color:#5881EB"></i> ${
              params.seriesName
            } ${res}${res !== '—' ? pageData.unit : ''}</div></div>`
          }
        },
        grid: [
          {
            top: 30,
            left: 10,
            right: 20,
            bottom: 40,
            containLabel: true
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              show: false
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              interval: 0
            }
          }
        ],
        yAxis: {
          type: 'value',
          splitNumber: 3,
          splitLine: {
            lineStyle: {
              color: props.theme === 'dark' ? '#252A34' : '#DBDFE6'
            }
          },
          axisLabel: {
            formatter: function (value: any) {
              if (Math.abs(value) >= 100000000 && value !== 0) {
                return (value / 100000000).toFixed(2) + '亿'
              } else if (Math.abs(value) >= 10000 && value !== 0) {
                return (value / 10000).toFixed(2) + '万'
              } else {
                return value
              }
            }
          }
        },
        series: [
          {
            name: pageData.chartTit,
            type: 'bar',
            barWidth: 34,
            data: yAxisData,
            position: 'outside'
          }
        ]
      }
    }
    // var myChart: any = null
    // onMounted(() => {
    //   const elem: HTMLElement = document.getElementById('NumberofShareholders') as HTMLElement
    //   if (myChart != null && myChart != '' && myChart != undefined) {
    //     myChart.dispose() //销毁
    //   }

    //   myChart = echarts.init(elem)
    //   myChart.setOption(pageData.option)
    // })
    watch(
      () => pageData.data,
      () => {
        nextTick(() => {
          pageData.option = setOptions()
        })
      }
    )
    watch(
      () => pageData.chartKey,
      () => {
        nextTick(() => {
          pageData.option = setOptions()
        })
      }
    )
    // watch(
    //   () => pageData.option,
    //   () => {
    //     const elem: HTMLElement = document.getElementById('NumberofShareholders') as HTMLElement
    //     if (myChart != null && myChart != '' && myChart != undefined) {
    //       myChart.dispose() //销毁
    //     }
    //     myChart = echarts.init(elem)
    //     myChart.setOption(pageData.option)
    //   }
    // )
    watch(
      () => (props.pageSourceData || {}).Quota,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Quota' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
          // setoption()
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      checkTag,
      checkCurrent,
      getNumber: globalsets.getNumber
    }
  }
})
